export default __webpack_public_path__ + "static/media/recommend.3ae0de1c.jpg";